import {
  SubTitleSmall,
  TitleMedium,
} from '@spaced-out/ui-design-system/lib/components/Text';
import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import type {ReferralJob, ReferralJobData} from 'src/types/referral-v2';
import {
  selectJobs as selectExternalJobs,
  selectJobDescription,
} from 'src/selectors/referral-external';
import {Icon} from '@spaced-out/ui-design-system/lib/components/Icon';
import {
  PanelBody,
  PanelFooter,
} from '@spaced-out/ui-design-system/lib/components/Panel';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {Chip} from '@spaced-out/ui-design-system/lib/components/Chip';
import {useDispatch, useSelector} from 'react-redux';
import type {JobResponse} from 'src/types/referral-external';
import {useAsyncDependency} from 'src/hooks/useAsyncDependency';
import {selectJobs} from 'src/selectors/referral-v2';
import {fetchDescription} from 'src/action-creators/referral-external';
import {CircularLoader} from '@spaced-out/ui-design-system/lib/components/CircularLoader';
import css from 'src/components/referral-external/jobs/jobs.css';


const JobDetails = ({
  setJobDetailsOpen,
  handleSelectJob,
  jobId,
}: {
  setJobDetailsOpen?: (arg1: boolean) => void;
  handleSelectJob?: (arg1: ReferralJob) => void;
  jobId: string;
}) => {
  const {t, makeKey} = useLabelTranslation();
  const dispatch = useDispatch();
  const jobs = useSelector(selectExternalJobs);
  const jobDescription = useSelector(selectJobDescription);
  // @ts-expect-error - TS2322 - Type 'ReferralJobData[] | null | undefined' is not assignable to type 'ReferralJobData | null | undefined'.
  const referralJobData: ReferralJobData | null | undefined =
    useSelector(selectJobs);
  const JobList: ReferralJob | null | undefined = referralJobData?.jobs.find(
    (job: ReferralJob) => job.id === jobId,
  );
  // @ts-expect-error - TS2322 - Type 'JobResponse | undefined' is not assignable to type 'JobResponse'.
  const job: JobResponse = (jobs || []).find((job) => job.id === jobId);

  const descriptionLoading = useAsyncDependency(() => {
    return dispatch(fetchDescription(jobId));
  }, []);

  const {payout_amount, location: jobLocation, title: jobTitle} = JobList || {};

  const {
    id = jobId,
    job_type,
    payment_type,
    bonus = {amount: payout_amount, currency: 'USD'},
    location = jobLocation,
    title = jobTitle,
  } = job || {};
  return (
    <>
      <PanelBody>
        <div className={css.jobDetailsBody}>
          {title ? <TitleMedium>{title}</TitleMedium> : null}
          {location ? (
            <div className={css.button}>
              <Icon
                color="tertiary"
                name="location-dot"
                size="medium"
                type="regular"
              />
              <SubTitleSmall color="secondary">{location}</SubTitleSmall>
            </div>
          ) : null}
          <div className={css.descriptionContainer}>
            <div className={css.chip}>
              {bonus && bonus.amount ? (
                bonus.currency === 'USD' ? (
                  <Chip
                    iconName="dollar"
                    semantic="secondary"
                    classNames={{wrapper: css.chipCursor}}
                  >
                    {`${bonus.amount} ${t('Bonus', 'Bonus')}`}
                  </Chip>
                ) : (
                  <Chip
                    semantic="secondary"
                    classNames={{wrapper: css.chipCursor}}
                  >{`${bonus.amount} ${t('Bonus', 'Bonus')}`}</Chip>
                )
              ) : null}
              {job_type ? (
                <Chip
                  iconName="briefcase"
                  semantic="secondary"
                  classNames={{wrapper: css.chipCursor}}
                >
                  {t(makeKey(job_type), job_type)}
                </Chip>
              ) : null}
              {payment_type ? (
                <Chip
                  iconName="wallet"
                  semantic="secondary"
                  classNames={{wrapper: css.chipCursor}}
                >
                  {t(makeKey(payment_type), payment_type)}
                </Chip>
              ) : null}
              <Chip semantic="secondary" classNames={{wrapper: css.chipCursor}}>
                {t('Job_ID', 'Job ID')}: {id}
              </Chip>
            </div>
          </div>
          {descriptionLoading ? (
            <div className={css.loadingState}>
              <CircularLoader colorToken="colorFillPrimary" size="medium" />
            </div>
          ) : (
            <div
              className={css.description}
              dangerouslySetInnerHTML={{
                __html: jobDescription.description || '<p></p>',
              }}
            />
          )}
        </div>
      </PanelBody>

      {handleSelectJob && (
        <PanelFooter>
          <div className={css.chip}>
            <Button
              onClick={() => {
                // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
                handleSelectJob({id, title});
                setJobDetailsOpen?.(false);
              }}
            >
              {t('Select', 'Select')}
            </Button>
          </div>
        </PanelFooter>
      )}
    </>
  );
};

export default JobDetails;
